import { render } from "./MatchView.vue?vue&type=template&id=40b125e5&scoped=true"
import script from "./MatchView.vue?vue&type=script&lang=js"
export * from "./MatchView.vue?vue&type=script&lang=js"

import "./MatchView.vue?vue&type=style&index=0&id=40b125e5&scoped=true&lang=css"

import exportComponent from "/Users/georgeconstantine/Documents/import/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b125e5"]])

export default __exports__